import { useEffect, useState } from 'react';

import { isBrowser } from '../helpers/is-browser';
import { useIsMobile } from './use-is-mobile';

const useGetMobileAppWebViewHeader = () => {
  const [isMobileAppWebView, setIsMobileAppWebView] = useState(() => {
    if (isBrowser && sessionStorage.getItem('MobileApp-WebView') === 'true') {
      return true;
    }
    return false;
  });

  const isMobile = useIsMobile();

  useEffect(() => {
    if (isBrowser) {
      const windowUrl = window.location.search;
      const params = new URLSearchParams(windowUrl);
      const webView = params.get('MobileApp-WebView');
      if (webView === 'true') {
        sessionStorage.setItem('MobileApp-WebView', 'true');
        setIsMobileAppWebView(true);
      }
    }
  }, []);

  return isMobile && isMobileAppWebView;
};

export default useGetMobileAppWebViewHeader;
